import React, { ReactElement } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';

export type ISelectOption = {
    name: string;
    value: any;
};

export type ISelectOptionProps = IQATestableProps & {
    option: ISelectOption;
    index: number;
};

export function OzSelectInputOption (props: ISelectOptionProps): ReactElement {
    const {
        option,
        index,
        'data-testid': dataTest = '',
    }: ISelectOptionProps = props;

    return (
        <option
            key={index}
            value={index}
            data-testid={!!dataTest && `${dataTest}-select-option-${index}`}
        >
            {option.name}
        </option>
    );
}
